import React from 'react';

import { Stack } from '@metarouter-private/mr-mui';

import ActivationActions from './ActivationActions';
import DeleteActions from './DeleteActions';

export default function ActionsCell(row) {
  return (
    <Stack direction="row" display="flex" alignItems="center" spacing={1}>
      <ActivationActions {...row} />
      <DeleteActions {...row} />
    </Stack>
  );
}
